  document.addEventListener('DOMContentLoaded', function() {

    const accordionItems = document.querySelectorAll('.lp-faq-question');
    if (accordionItems.length){
        document.querySelectorAll('.lp-faq-question').forEach(function(q) {
        q.addEventListener('click', function() {
            const item = this.parentElement;
            console.log(item);
            const isActive = item.classList.contains('active');
            document.querySelectorAll('.lp-faq-accordion-item').forEach(function(i) {
            i.classList.remove('active');
            });
            if (!isActive) {
            item.classList.add('active');
            }
        });
        q.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
            }
        });
        });
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    const lightboxYoutubeLinks = document.querySelectorAll('a[data-fslightbox][href*="youtube.com/"], a[data-fslightbox][href*="youtu.be/"]');

    lightboxYoutubeLinks.forEach(function(link) {
      const href = link.getAttribute('href');

      if (!link.hasAttribute('data-allow')) {
        link.setAttribute('data-allow', 'autoplay; encrypted-media; fullscreen');
      }

      if (href) {
        try {
          const parsedUrl = new URL(href, window.location.origin);

          if (!parsedUrl.searchParams.has('enablejsapi')) {
            parsedUrl.searchParams.set('enablejsapi', '1');
          }

          if (!parsedUrl.searchParams.has('origin')) {
            parsedUrl.searchParams.set('origin', window.location.origin);
          }

          link.setAttribute('href', parsedUrl.toString());
        } catch (error) {
          // Keep original href when URL parsing fails.
        }
      }

      if (!link.hasAttribute('data-autoplay')) {
        link.setAttribute('data-autoplay', '1');
      }
    });

    const shortsLinks = document.querySelectorAll('a[data-fslightbox][href*="youtube.com/shorts/"]');

    shortsLinks.forEach(function(link) {
      const originalHref = link.getAttribute('href');

      if (!originalHref) {
        return;
      }

      try {
        const parsedUrl = new URL(originalHref, window.location.origin);
        const shortsMatch = parsedUrl.pathname.match(/\/shorts\/([^/?#]+)/);

        if (!shortsMatch || !shortsMatch[1]) {
          return;
        }

        const normalizedUrl = new URL('https://www.youtube.com/watch');
        normalizedUrl.searchParams.set('v', shortsMatch[1]);

        parsedUrl.searchParams.forEach(function(value, key) {
          if (key !== 'v') {
            normalizedUrl.searchParams.set(key, value);
          }
        });

        if (!normalizedUrl.searchParams.has('autoplay')) {
          normalizedUrl.searchParams.set('autoplay', '1');
        }

        link.setAttribute('href', normalizedUrl.toString());
      } catch (error) {
        // Keep original href when URL parsing fails.
      }
    });

    if (typeof window.refreshFsLightbox === 'function') {
      window.refreshFsLightbox();
    }

    function sendYoutubeCommand(iframe, func, args) {
      if (!iframe || !iframe.contentWindow) {
        return;
      }

      iframe.contentWindow.postMessage(JSON.stringify({
          event: 'command',
          func: func,
          args: args || []
      }), '*');
    }

    function getMostVisibleIframe(iframes) {
      let activeIframe = null;
      let maxVisibleArea = 0;

      iframes.forEach(function(iframe) {
        const rect = iframe.getBoundingClientRect();
        const visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
        const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
        const visibleArea = visibleWidth * visibleHeight;

        if (visibleArea > maxVisibleArea) {
          maxVisibleArea = visibleArea;
          activeIframe = iframe;
        }
      });

      return activeIframe;
    }

    function syncYoutubePlaybackToActiveSlide() {
      const iframes = Array.from(document.querySelectorAll('.fslightbox-container iframe[src*="youtube.com/embed/"]'));
      if (!iframes.length) {
        return;
      }

      const activeIframe = getMostVisibleIframe(iframes) || iframes[0];

      iframes.forEach(function(iframe) {
        if (iframe === activeIframe) {
          sendYoutubeCommand(iframe, 'playVideo', []);
          sendYoutubeCommand(iframe, 'setVolume', [30]);
          sendYoutubeCommand(iframe, 'unMute', []);
          return;
        }

        sendYoutubeCommand(iframe, 'pauseVideo', []);
      });
    }

    function applyAutoplaySetupToOpenYoutubeIframes() {
      const iframes = document.querySelectorAll('.fslightbox-container iframe[src*="youtube.com/embed/"]');

      iframes.forEach(function(iframe) {
        sendYoutubeCommand(iframe, 'playVideo', []);
        sendYoutubeCommand(iframe, 'setVolume', [30]);
      });
    }

    window.addEventListener('message', function(event) {
      if (!event.origin || event.origin.indexOf('youtube.com') === -1) {
        return;
      }

      let payload = event.data;
      if (typeof payload === 'string') {
        try {
          payload = JSON.parse(payload);
        } catch (error) {
          return;
        }
      }

      if (!payload || payload.event !== 'onReady') {
        return;
      }

      const iframes = document.querySelectorAll('.fslightbox-container iframe[src*="youtube.com/embed/"]');
      iframes.forEach(function(iframe) {
        if (iframe.contentWindow !== event.source) {
          return;
        }

        sendYoutubeCommand(iframe, 'playVideo', []);
        sendYoutubeCommand(iframe, 'unMute', []);
        sendYoutubeCommand(iframe, 'setVolume', [30]);

        setTimeout(function() {
          sendYoutubeCommand(iframe, 'unMute', []);
          sendYoutubeCommand(iframe, 'setVolume', [30]);
          sendYoutubeCommand(iframe, 'playVideo', []);
          syncYoutubePlaybackToActiveSlide();
        }, 300);
      });
    });

    let lightboxPlaybackWatcher = null;

    function startLightboxPlaybackWatcher() {
      if (lightboxPlaybackWatcher) {
        clearInterval(lightboxPlaybackWatcher);
      }

      lightboxPlaybackWatcher = setInterval(function() {
        const lightboxContainer = document.querySelector('.fslightbox-container');

        if (!lightboxContainer) {
          clearInterval(lightboxPlaybackWatcher);
          lightboxPlaybackWatcher = null;
          return;
        }

        syncYoutubePlaybackToActiveSlide();
      }, 220);
    }

    document.addEventListener('click', function(event) {
      const trigger = event.target.closest('a[data-fslightbox][href*="youtube.com/"], a[data-fslightbox][href*="youtu.be/"]');

      if (!trigger) {
        return;
      }

      let attempts = 0;
      const maxAttempts = 40;
      const pollInterval = setInterval(function() {
        applyAutoplaySetupToOpenYoutubeIframes();
        syncYoutubePlaybackToActiveSlide();
        attempts += 1;

        if (attempts >= maxAttempts) {
          clearInterval(pollInterval);
        }
      }, 120);

      startLightboxPlaybackWatcher();
    });
  }); 